<div [ngStyle]="{ 'max-width': '150px' }" class="u-marginBottom-24">
  <app-logo-square size="small" class="u-display-block" color="blue-900">
  </app-logo-square>
</div>
<h6 i18n="@@noLocalStoragePrompt.title" class="u-marginBottom-16">Sorry.</h6>
<div i18n="@@noLocalStoragePrompt.content" [ngStyle]="{ 'max-width': '300px' }">
  We are unable to log you in using a browser in private mode.
</div>
